const actionTypeIdentifier = 'D1747114-0CFF-4AAC-A241-F8FC52F6282E';

export const getCircuitOrder = `GET-CIRCUIT-ORDER-${actionTypeIdentifier}`;
export const getCircuitOrderAllCircuitStatusesDropdown = `GET-CIRCUIT-ORDER-ALL-CIRCUIT-STATUSES-DROPDOWN-${actionTypeIdentifier}`;
export const getCircuitOrderCircuitTypesByCategoryDropdown = `GET-CIRCUIT-ORDER-CIRCUIT-TYPES-BY-CATEGORY-DROPDOWN-${actionTypeIdentifier}`;
export const getCircuitOrderSubCircuitTypesDropdown = `GET-CIRCUIT-ORDER-CIRCUIT-SUB-CIRCUIT-TYPES-DROPDOWN-${actionTypeIdentifier}`;
export const getCircuitOrderAllCircuitRankingsDropdown = `GET-CIRCUIT-ORDER-ALL-CIRCUIT-RANKINGS-DROPDOWN-${actionTypeIdentifier}`;
export const getCircuitOrderAllAccountDetailsDropdown = `GET-CIRCUIT-ORDER-ALL-ACCOUNTS-DETAILS-DROPDOWN-${actionTypeIdentifier}`;
export const getlinkCircuitsByVendorIdAndCircuitTypeId = `GET-CIRCUIT-ORDER-LINK-CIRCUITS-BY-BILLING-ACCOUNT-ID-AND_CIRCUIT-TYPE-ID-DROPDOWN${actionTypeIdentifier}`;
export const getCircuitOrderAllEmployeesDropdown =  `GET-CIRCUIT-ORDER-ALL-EMPLOYEES-DROPDOWN-${actionTypeIdentifier}`;
export const getCircuitOrderAllLocations = `GET-CIRCUIT-ORDER-ALL-LOCATIONS-${actionTypeIdentifier}`;
export const getCircuitOrderAllLocations1 = `GET-CIRCUIT-ORDER-ALL-LOCATIONS-1-${actionTypeIdentifier}`;
export const getCircuitOrderAllLocations2 = `GET-CIRCUIT-ORDER-ALL-LOCATIONS-2-${actionTypeIdentifier}`;
export const setCircuitOrderFormSubmitted = `SET-CIRCUIT--ORDER-FORM-SUBMITTED-${actionTypeIdentifier}`;
export const getOrderCircuitCostCenterList = `GET-ORDER-CIRCUIT-COST-CENTER-LIST-${actionTypeIdentifier}`;
export const getOrderCircuitGlCodeList = `GET-ORDER-CIRCUIT-GL-COST-LIST-${actionTypeIdentifier}`;
export const setLocationLoading = `SET-LOCATION-LOADING-${actionTypeIdentifier}`;
export const setEmployeeLoading = `SET-EMPLOYEE-LOADING-${actionTypeIdentifier}`;
export const setSubCircuitTypeLoading = `SET-SUB-CIRCUIT-TYPE-LOADING-${actionTypeIdentifier}`;
export const setLinkedCircuitsLoading = `SET-LINKED-CIRCUITS-LOADING-${actionTypeIdentifier}`;
export const setBillingAccountLoading = `SET-BILLING-ACCOUNT-LOADING-${actionTypeIdentifier}`;
export const setCostCodeLoading = `SET-COST-CODE-LOADING-${actionTypeIdentifier}`;
export const setGlCodeLoading = `SET-GL-CODE-LOADING-${actionTypeIdentifier}`;
export const setLocation1Loading = `SET-LOCATION-1-LOADING-${actionTypeIdentifier}`;
export const setLocation2Loading = `SET-LOCATION-2-LOADING-${actionTypeIdentifier}`;

export const circuitOrderFormModel = {
    orderId: 0,
    orderNumber: '',
    circuitCodeConfirmation: false,
    primarySecondaryConfirmation: false,
    circuitID: 0,
    circuitCode: "",
    statusID: 0,
    circuitTypeID: 0,
    subCircuitTypeID: 0,
    monthlyRateCharge: "0.00",
    primarySecondary: "",
    linkedCircuitID: "",
    billingAccountID: 0,
    financeAccountTypeName: "",
    clientName: "",
    vendor: "",
    endUserID: "",
    userName: "",
    emailAddress: "",
    lineManager: "",
    installDate: "",
    disconnectDate: "",
    suspensionFromDate: "",
    suspensionToDate: "",
    orderStatusID : 0
};

export const locationModel = {
    locationID: "",
    address1: "",
    address2: "",
    locationType: "",
    locationCity: "",
    locationState: "",
    locationCountry: "",
    locationZip: "",
    demarcLocation: ""
};